var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.880761 7.51914C1.38844 8.02682 2.21156 8.02682 2.71924 7.51914L7 3.23838L11.2808 7.51914C11.7884 8.02682 12.6116 8.02682 13.1192 7.51914C13.6269 7.01146 13.6269 6.18834 13.1192 5.68066L7.91924 0.480663C7.41156 -0.027019 6.58844 -0.027019 6.08076 0.480663L0.880761 5.68066C0.37308 6.18834 0.37308 7.01146 0.880761 7.51914Z",
    fill: "#4EAAAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropUp);
export default __webpack_public_path__ + "static/media/drop-up.e21cd6a8.svg";
export { ForwardRef as ReactComponent };